export enum CANALS {
  ONLINE = 1,
  OFFLINE = 2
}
